/** SP3 §2 — client gate for balance-affecting station actions (repair,
 *  allocation edits, override, apply-check-amount, accept in combined/balance
 *  mode). The server is authoritative; this only decides whether to render. */
export function canBalanceRemittance(user: { permissions?: string[] } | null | undefined): boolean {
  return !!user?.permissions?.includes("remittance.balance");
}
export function canKeyRemittance(user: { permissions?: string[] } | null | undefined): boolean {
  return !!user?.permissions?.includes("remittance.key") || canBalanceRemittance(user);
}
